import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { truncate } from 'lodash'
import Image from 'components/image'
import Card from 'components/card'
import PampersRewardLink from 'components/pamper-registration-modal-legacy-adapter'
import dateformat from 'dateformat'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ReviewButton } from 'store/components/product-reviews'
import ReturnLink from './gift-returns/components/return-link'
import UnreserveLink from './unreserve-link'
import GiftActions from './gift-actions'
import * as css from './reservation-card.scss'

const ReservationCard = ({ reservation }, { registry, user }) => {
  const {
    regItem,
    isPurchased,
    createdAt,
    purchasedAt,
    quantity,
    trackingInfos,
    displayTitle,
  } = reservation

  const title = displayTitle

  return (
    <Card className={css.card}>
      <div className={css.thumbnail}>
        <Image role="presentation" src={regItem.imgUrl} width="100%" />
      </div>
      <div className={classNames(css.title)}>
        <span>{truncate(title, { length: 70 })}</span>
        {regItem.isPampersProduct && (
          <PampersRewardLink user={user} registry={registry} />
        )}
        <GiftActions trackingInfos={trackingInfos} className="hidden-xs mbm" />
        {isPurchased && (
          <div className={classNames(css.status, 'hidden-xs pbs-sm')}>
            {purchasedAt
              ? `Purchased on ${dateformat(purchasedAt, 'longDate')} `
              : 'Marked as Purchased '}
            <i className="fa fa-check text-success" />
          </div>
        )}
        {!regItem.isActive && (
          <div className={classNames(css.status)}>
            This item was reserved but removed from your registry.
            <OverlayTrigger
              overlay={
                <Tooltip id="tooltip" className="h7">
                  Gift givers will no longer see the option to buy this item,
                  but it may have been purchased already.
                </Tooltip>
              }
            >
              <i className="fa fa-info-circle mls text-muted" />
            </OverlayTrigger>
          </div>
        )}
        {regItem.isActive && !isPurchased && (
          <UnreserveLink reservation={reservation} />
        )}
      </div>
      <div className={css.meta}>
        <span>Reserved</span> <span>{dateformat(createdAt, 'mediumDate')}</span>
        {isPurchased ? (
          <>
            <span className="visible-xs">Purchased</span>
            <span className="visible-xs">
              {purchasedAt ? (
                `Purchased on ${dateformat(purchasedAt, 'mediumDate')} `
              ) : (
                <i className="fa fa-check text-success" />
              )}
            </span>
          </>
        ) : (
          <>
            <span className="visible-xs">Purchased</span>{' '}
            <span className="visible-xs text-muted text-italic">
              Not yet purchased
            </span>
          </>
        )}
        <span>Qty</span> <span>{quantity}</span>
        <PurchaseDetails reservation={reservation} />
      </div>
    </Card>
  )
}

ReservationCard.propTypes = {
  reservation: PropTypes.object.isRequired,
}

ReservationCard.contextTypes = {
  registry: PropTypes.object,
  user: PropTypes.object,
}

export default ReservationCard

const PurchaseDetails = ({ reservation }) => {
  const { isPurchased, orderNumber, storeName, trackingInfos, regItem } =
    reservation

  return isPurchased ? (
    <>
      <span>Store</span>{' '}
      <span className={classNames({ 'text-muted text-italic': !storeName })}>
        {storeName || 'Not yet provided'}
      </span>
      <span>Order #</span>{' '}
      <span className={classNames({ 'text-muted text-italic': !orderNumber })}>
        {orderNumber || 'Not yet provided'}
      </span>
      <span className={css.spanColumn}>
        <GiftActions trackingInfos={trackingInfos} className="visible-xs" />
        <ReturnLink reservation={reservation} />
        <ReviewButton sku={regItem.turntoSku} />
      </span>
    </>
  ) : null
}

PurchaseDetails.propTypes = {
  reservation: PropTypes.object.isRequired,
}
